import { render, staticRenderFns } from "./PanelTemplate.vue?vue&type=template&id=39b26c80"
import script from "./PanelTemplate.vue?vue&type=script&lang=js"
export * from "./PanelTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports